/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { NotificationItem } from "../types/NotificationItem";

export function getErrorFromCode(code: string): NotificationItem {
    switch (code) {
        case "invalidUser":
        case "auth/user-not-found":
            return {
                code,
                variant: "error",
                message:
                    "Compte inexistant. Si c'est votre première connexion, veuillez cliquer sur le lien \"Première utilisation ?\" pour créer votre compte",
            };
        case "auth/email-already-in-use":
            return {
                code,
                variant: "error",
                message: "Compte existe déjà.",
            };
        case "auth/week-password":
            return {
                code,
                variant: "error",
                message: "Mot de passe trop faible.",
            };
        case "auth/network-request-failed":
            return {
                code,
                variant: "error",
                message: "Impossible de se connecter en mode 'Offline'.",
            };
        case "auth/wrong-password":
            return {
                code: "auth/wrong-password",
                message: "Mot de passe invalide",
                variant: "error",
            };
        case "auth.invalidEmail":
            return {
                code,
                variant: "error",
                message: "Cet email n'existe pas dans notre base de données, veuillez contacter le support.",
            };
        case "auth.offlineLogout":
            return {
                code,
                variant: "error",
                message: "Déconnexion impossible parce que vous êtes 'offline'.",
            };
        case "me.offlineSu":
            return {
                code,
                variant: "error",
                message: "Sudo mode exige une connexion internet"
            };
        case "me.suProfileNotCompleted":
            return {
                code,
                variant: "error",
                message: "Votre commercial doit d'abord valider son profil."
            };
        case "me.offlineAdvisors":
            return {
                code,
                variant: "warning",
                message: "Cette page n'est pas à jour puisque vous êtes 'offline'."
            };
        default:
            return {
                code,
                variant: "error",
                message: `Erreur du code: ${code}`,
            };
    }
}



// WEBPACK FOOTER //
// ./src/utils/errorHelper.ts